import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { FormGroup } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-multiple-file-uploader',
  imports: [CommonModule, NgxDropzoneModule, ReactiveFormsModule],
  templateUrl: './multiple-file-uploader.component.html',
  styleUrl: './multiple-file-uploader.component.scss',
})
export class MultipleFileUploaderComponent {
  @Input() label: string = '';
  @Input() acceptFileType: string = '';
  @Input() acceptFileSize: number = 2 ;
  @Input() uploaderHeading: string = '';
  @Input() hintText: string = '';
  @Input() showProfileImg: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() isUploaded: boolean = false;
  @Input() dummyImageUrl: string = '';
  @Input() formGroup!: FormGroup;
  @Input() formControlValue!: string;
  @Output() onSelectFile: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRemoveFile: EventEmitter<any> = new EventEmitter<any>();
  @Input() preview: string = '';

  errorMessage: string | null = null;

  files!: any;

  ngOnInit(): void {
    if (this.formControlValue) {
      // this.preview = this.formControlValue;
      this.preview = this.formGroup.controls[this.formControlValue].value;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setPreviewFromForm();    
  }

  private setPreviewFromForm() {
    if (this.formGroup && this.formControlValue) {
      const value = this.formGroup.get(this.formControlValue)?.value;
      if (value && typeof value === 'string' && value.startsWith('http')) {
        this.preview = value;
      }
    }
  }

  onSelect(event: any) {
    const rejectedFile = event.rejectedFiles[0];
    if(rejectedFile){
      const allowedExtensions = this.acceptFileType
        .split(',')
        .map(ext => ext.trim().toLowerCase());
      const fileExtension = '.' + rejectedFile.name.split('.').pop()?.toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        this.errorMessage = `Invalid file type. Accepted Formats are: ${this.acceptFileType}`;
        this.files = null;
        this.preview = this.dummyImageUrl;
        return;
      }
    }
    this.errorMessage = null;
    const selectedFile = event.addedFiles[0];
    //if file size is greater than 2 mb
    if(selectedFile.size > this.acceptFileSize * 1024 * 1024){this.onSelectFile.emit(event); return;}
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.preview = e.target.result;
    }; // Set preview URL
    reader.readAsDataURL(selectedFile);
    this.files = selectedFile;
    this.onSelectFile.emit(event);
  }

  onRemove(event: any) {
    this.files = null;
    this.preview = this.dummyImageUrl;
    this.onRemoveFile.emit(event);
  }
}
